export enum ZervantPlanTier {
  Plus = 'plus',
  Start = 'start',
}
